// @flow
import React, { useEffect } from 'react';
import Tips from '../../components/tips/Tips';
import useTips from '../../hooks/tips';
import usePods from '../../hooks/pods';

export default function AppTips() {
	const [{ state = false } = {}, toggleTips] = useTips();
	const [{ affiliateActive = false, selectedPod } = {}] = usePods();

	useEffect(() => {
		if (state) {
			window.scrollTo(0, 0);
			document.body && (document.body.style.overflow = 'hidden');
		} else {
			document.body && (document.body.style.overflow = '');
		}
	}, [state]);

	return (
		state && (
			<section
				style={{
					position: 'absolute',
					zIndex: 4,
					height: '100vh',
					width: '100%',
					left: 0,
					top: 0,
					backgroundColor: '#f05b83',
					overflow: 'scroll',
				}}
			>
				<Tips onClose={() => toggleTips(false)} affiliate={affiliateActive} selectedPod={selectedPod} />
			</section>
		)
	);
}
